import React from 'react'
import PropTypes from 'prop-types'

import { RangeSlider } from '@aok/ui-elements'

import M047QuestionLayout from '../M047QuestionLayout/M047QuestionLayout'

import defaultProps from '../../../../utils/propTypes/defaultProps'

const M047RangeSliderSelection = ({
  headline,
  subtitle,
  options,
  navigateToNextPage,
  navigateToPreviousPage,
  onChangeCallback,
}) => {
  const handleRangeSliderChange = (event) => {
    const updatedOptions = options.map((option) => {
      if (event.target.name === option?.id) {
        return { ...option, selected: parseInt(event.target.value) }
      } else {
        return option
      }
    })

    onChangeCallback(updatedOptions)
  }

  return (
    <M047QuestionLayout
      headline={headline}
      subtitle={subtitle}
      onNextButtonClick={navigateToNextPage}
      onPreviousButtonClick={navigateToPreviousPage}
      nextButtonDisabled={false}
    >
      <fieldset className="-mx-8 720:-mx-16">
        <legend className="sr-only">{headline?.text}</legend>
        <div className="space-y-40">
          {options.map((option) => (
            <RangeSlider
              key={option?.id}
              bgVariant="structure"
              min={0}
              max={option?.weight}
              step={1}
              label={option?.text}
              value={option?.selected}
              onChange={handleRangeSliderChange}
              name={option?.id}
              labelVisibility={options?.length > 1 ? 'show' : 'hide'}
            />
          ))}
        </div>
      </fieldset>
    </M047QuestionLayout>
  )
}

M047RangeSliderSelection.propTypes = {
  headline: PropTypes.shape({
    tag: PropTypes.string,
    text: PropTypes.string,
  }),
  subtitle: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      text: PropTypes.string,
      weight: PropTypes.number,
      selected: PropTypes.number, // stores currently selected value between 0 and weight
    })
  ),
  navigateToNextPage: PropTypes.func,
  navigateToPreviousPage: PropTypes.func,
  onChangeCallback: PropTypes.func,
}

M047RangeSliderSelection.defaultProps = {
  headline: {
    text: defaultProps.HEADLINE,
  },
  options: [],
  navigateToNextPage: () => {},
  navigateToPreviousPage: () => {},
  onChangeCallback: () => {},
}

export default M047RangeSliderSelection
